import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { loadingIndicator, dataEndMessage } from "../../../../shared/utilitiies"
import CalenderCard from "../../../../shared/components/ViewCalender/CalenderCard";

const UpcomingCalender = ({
  gridState,
  setGridState,
  calenderArray,
  flag,
  ...props
}) => {
  const { t } = useTranslation();

  //-------Get More Centers List on Scroll
  const getMoreCalenderDetails = () => {
    const updatedGridState = { ...gridState, length: gridState.length + 7 };
    setGridState(updatedGridState);
  };


  return (
    <InfiniteScroll
      dataLength={calenderArray?.length  || 0}
      next={getMoreCalenderDetails}
      hasMore={
        calenderArray?.length % 7 === 0 && calenderArray?.length !== 0
          ? true
          : false
      }
      loader={loadingIndicator(t)}
      endMessage={dataEndMessage(t , calenderArray)}
      style={{ overflow: "hidden" }}
      scrollableTarget={"main-container"}
      className="text-center justify-content-center align-items-center"
    >
      <div className="row m-0 w-100">
        {calenderArray?.map((activity) => {
          return (
            <CalenderCard
              activity={activity}
              flag={flag}
            />
          );
        })}
      </div>
    </InfiniteScroll>
  );
};

export default UpcomingCalender;
